import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {
  ChildWalletFundIndicators,
  Indicator,
  IndicatorsResponse,
} from 'src/types/wallet';
import { UQBAR_DATE_FORMAT, UQBAR_TIMEZONE } from 'src/utils/date';

dayjs.extend(utc);
dayjs.extend(timezone);

function filterIndicators(
  indicators: Indicator[],
  indicatorsCompetencyDate: string,
): Indicator[] {
  return indicators.filter(
    (indicator) =>
      dayjs(indicator.document_date)
        .tz(UQBAR_TIMEZONE)
        .format(UQBAR_DATE_FORMAT) === indicatorsCompetencyDate,
  );
}

function filterChildWalletFundIndicators(
  walletFund: ChildWalletFundIndicators,
  indicatorsCompetencyDate: string,
): ChildWalletFundIndicators {
  const childrenWalletFunds = walletFund.childrenWalletFunds?.map((child) =>
    filterChildWalletFundIndicators(child, indicatorsCompetencyDate),
  );

  return {
    ...walletFund,
    indicators: filterIndicators(
      walletFund.indicators,
      indicatorsCompetencyDate,
    ),
    ...(childrenWalletFunds ? { childrenWalletFunds } : {}),
  };
}

export function filterIndicatorsByCompetencyDate(
  indicatorsResponse: IndicatorsResponse,
  indicatorsCompetencyDate: string,
): IndicatorsResponse {
  const childrenWalletFunds = indicatorsResponse.childrenWalletFunds?.map(
    (child) => filterChildWalletFundIndicators(child, indicatorsCompetencyDate),
  );

  return {
    ...indicatorsResponse,
    indicators: filterIndicators(
      indicatorsResponse.indicators,
      indicatorsCompetencyDate,
    ),
    ...(childrenWalletFunds ? { childrenWalletFunds } : {}),
  };
}
